"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LifecycleState = void 0;
/**
 * Состояния жизненного цикла страницы.
 */
var LifecycleState;
(function (LifecycleState) {
    /** Активное состояние, если страница видна и имеет фокус ввода. **/
    LifecycleState["ACTIVE"] = "active";
    /** Пассивное состояние, если страница видна и не имеет фокуса ввода. **/
    LifecycleState["PASSIVE"] = "passive";
    /** Скрытое состояние, если страница не видна и не была заморожена. **/
    LifecycleState["HIDDEN"] = "hidden";
    /** Замороженное состояние. **/
    LifecycleState["FROZEN"] = "frozen";
    /** Закрытое состояние, если страница начала выгружаться и очищаться из памяти браузером. **/
    LifecycleState["TERMINATED"] = "terminated";
    /** Неизвестное состояние, fallback. **/
    LifecycleState["UNKNOWN"] = "unknown";
})(LifecycleState = exports.LifecycleState || (exports.LifecycleState = {}));
